import { Component } from "react";
import { Overlay } from "../Overlay/Overlay";
import { IoCloseOutline } from "react-icons/all";
require("./message.css");
interface IMessageProps {
  closeCallback: () => void;
  icon?: JSX.Element;
  title: JSX.Element | string;
  messageText: string;
  buttons: JSX.Element;
}
export default class MessageDialog extends Component<IMessageProps, {}> {
  render() {
    return (
      <Overlay isMenuOverlay={false} isDialogOverlay={true}>
        <div className={"closeIcon"}>
          {this.props.closeCallback ? (
            <IoCloseOutline onClick={() => this.props.closeCallback()} />
          ) : undefined}
        </div>
        <div className={"clearfix"}></div>
        <div>
          <div className={"iconContainer"}>{this.props.icon}</div>
          <div className={"titleContainer"}>{this.props.title}</div>
          <div className={"messageTextContainer"}>{this.props.messageText}</div>
          <div className={"buttonsContainer"}>{this.props.buttons}</div>
        </div>
      </Overlay>
    );
  }
}
